var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * API services for Proposal Contacts feature
 */
import api from '@utils/axios';
/**
 * Fetches all contacts for a proposal
 * @param proposalId - The proposal ID
 * @returns Promise with array of contacts
 */
export function getProposalContacts(proposalId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(`/api/internal/proposals/${proposalId}/contacts`);
            return response.data;
        }
        catch (error) {
            console.error('Error fetching proposal contacts:', error);
            throw error;
        }
    });
}
/**
 * Creates a new contact for a proposal
 * @param proposalId - The proposal ID
 * @param contactData - The contact data to create
 * @returns Promise with the created contact
 */
export function createProposalContact(proposalId, contactData) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.post(`/api/internal/proposals/${proposalId}/contacts`, {
                contact: contactData
            });
            return response.data;
        }
        catch (error) {
            console.error('Error creating proposal contact:', error);
            throw error;
        }
    });
}
/**
 * Updates an existing contact for a proposal
 * @param proposalId - The proposal ID
 * @param contactId - The contact ID
 * @param contactData - The contact data to update
 * @returns Promise with the updated contact
 */
export function updateProposalContact(proposalId, contactId, contactData) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(`/api/internal/proposals/${proposalId}/contacts/${contactId}`, {
                contact: contactData
            });
            return response.data;
        }
        catch (error) {
            console.error('Error updating proposal contact:', error);
            throw error;
        }
    });
}
/**
 * Deletes a contact from a proposal
 * @param proposalId - The proposal ID
 * @param contactId - The contact ID
 * @returns Promise with success response
 */
export function deleteProposalContact(proposalId, contactId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.delete(`/api/internal/proposals/${proposalId}/contacts/${contactId}`);
            return response.data;
        }
        catch (error) {
            console.error('Error deleting proposal contact:', error);
            throw error;
        }
    });
}
